module.exports = __webpack_public_path__ + "img/sakura.6fca079.png";